module.exports = __webpack_public_path__ + "img/2.01b7b1a8.png";